import styled from 'styled-components';

const Svg = styled.svg`
  ${({ theme: { spacing } }) => `
    width: ${spacing(4)};
    height: ${spacing(4)};
  `}
`;

type Props = {
  color: string;
  className?: string;
};

export const ChevronLeft = ({ className = '', color }: Props) => (
  <Svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3333 12.6673L6 8.00065L11.3333 3.33398L10.6667 2.66732C9.24667 3.79398 5.814 6.94132 4.66667 8.00065C5.51853 8.77532 4.6874 8.01398 10.6667 13.334L11.3333 12.6673Z"
      fill={color}
      stroke={color}
    />
  </Svg>
);
